import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme } from './styles/GlobalStyles';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Menu from './components/Menu/Menu';
import ProfessionalGallery from './components/ProfessionalGallery';
import Footer from './components/Footer/Footer';
import FranchiseDetails from './components/FranchiseDetails';
import ContactSection from './components/ContactSection';

// All components are now directly imported for better reliability

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <div className="App">
        <Header />
        <Hero />
        
        {/* Menu - Keep this loaded immediately as it's core functionality */}
        <Menu />
        
        {/* Professional Photography Gallery */}
        <ProfessionalGallery />
        
        <FranchiseDetails />
        <ContactSection />
        
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
